import { useCallback } from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';

import { useErrorText } from './hooks';
import { useFormatMessage } from '../../../../../../intl/intl';
import orderActions from '../../../../../../redux/actions/orders-actions';

import CustomButton, {
  Colors,
  Variants,
} from '../../../../../common/buttons/custom-button';

import useStyles from './styles';

import type { BaseProps } from '../../../../../../interfaces';

const retryButtonTextId = {
  id: 'orderDetailDialogTotalDetailFailedSection.retryButtonText',
};

export function FailedSection({ classes }: BaseProps) {
  const componentClasses = useStyles();

  const retryButtonText = useFormatMessage(retryButtonTextId);

  const errorText = useErrorText();

  const dispatch = useDispatch();

  const handleClickButton = useCallback(async () => {
    await dispatch(orderActions.retryLodingOrderTotals());
  }, [dispatch]);

  return (
    <div
      className={classNames(
        get(componentClasses, 'root', null),
        get(classes, 'root', null),
      )}
    >
      <div>{errorText}</div>
      <CustomButton
        classes={{
          submitButton: classNames(
            get(componentClasses, 'submitButton', null),
            get(classes, 'submitButton', null),
          ),
        }}
        color={Colors.SECONDARY}
        onClick={handleClickButton}
        variant={Variants.CONTAINED}
      >
        {retryButtonText}
      </CustomButton>
    </div>
  );
}
